export default "__VITE_ASSET__8c0f3065__"